import { render } from "./HomePhotoPanel.vue?vue&type=template&id=0d48973d&scoped=true&bindings={\"isLoading\":\"setup\",\"photos\":\"setup\"}"
import script from "./HomePhotoPanel.vue?vue&type=script&lang=js"
export * from "./HomePhotoPanel.vue?vue&type=script&lang=js"

import "./HomePhotoPanel.vue?vue&type=style&index=0&id=0d48973d&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-0d48973d"

export default script